import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-hotel",
  "use": "icon-hotel-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-hotel\"><path d=\"M512 810.635636h85.317818V256l272.802909 116.922182a42.682182 42.682182 0 0 1 25.879273 39.237818v398.522182h85.317818v85.317818H42.682182v-85.364364H128V241.058909a42.682182 42.682182 0 0 1 25.367273-39.005091l328.657454-146.106182a21.317818 21.317818 0 0 1 29.975273 19.549091z\" fill=\"#474CCE\" p-id=\"3452\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol